import { forwardRef } from "react";
import DocsSidebarDesktop from "./DocsSidebarDesktop";
import DocsMobileDrawer from "./DocsMobileDrawer";
import DocsMobileMenuButton from "./DocsMobileMenuButton";
import DocsBreadcrumb from "./DocsBreadcrumb";
import DocsPrevNext from "./DocsPrevNext";
import pageStyles from "../../styles/docs/docsPage.module.scss";

const DocsLayout = forwardRef(({
  docNav,
  activeId,
  onNavigate,
  activeGroup,
  activeItem,
  prev,
  next,
  mobileSidebarOpen,
  onMobileToggle,
  onMobileClose,
  children,
}, contentRef) => (
  <>
    <DocsMobileMenuButton open={mobileSidebarOpen} onToggle={onMobileToggle} />

    <div className={pageStyles.layout}>
      <DocsSidebarDesktop docNav={docNav} activeId={activeId} onNavigate={onNavigate} />

      <DocsMobileDrawer
        open={mobileSidebarOpen}
        onClose={onMobileClose}
        docNav={docNav}
        activeId={activeId}
        onNavigate={onNavigate}
      />

      <main ref={contentRef} className={pageStyles.main}>
        <DocsBreadcrumb
          groupLabel={activeGroup?.label}
          itemLabel={activeItem?.label}
        />

        <div className={pageStyles.contentWrapper}>
          {children}
          <DocsPrevNext docNav={docNav} prev={prev} next={next} />
        </div>
      </main>
    </div>
  </>
));

DocsLayout.displayName = "DocsLayout";

export default DocsLayout;
